import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons-dt/js/buttons.dataTables.min";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";

import "datatables.net-buttons/js/buttons.colVis.min";
import "datatables.net-buttons/js/buttons.print.min";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.flash.min";
import "datatables.net-buttons/js/dataTables.buttons.min";

import pdfMake from 'pdfmake/build/pdfmake.min';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import jzip from "jszip/dist/jszip";
import './DataTable.scss';


import jQuery from "jquery";

class DataTable {

    constructor(params) {

        window.JSZip = jzip;
        pdfMake.vfs = pdfFonts.pdfMake.vfs;

        this.params = params;
    }

    update(data) {
        jQuery(this.params.element ?? '#dataTable').dataTable().fnClearTable();
        if(!!data.length)
            jQuery(this.params.element ?? '#dataTable').dataTable().fnAddData(data);
    }

    static init(params) {

        jQuery(document).ready(function () {
            jQuery(params.element ?? '#dataTable').DataTable({
                dom: 'Bfrtip',
                select: true,
                buttons: [
                    {
                        extend: 'copy',
                        text: 'Копировать данные'
                    },
                    {
                        extend: 'csv',
                        text: 'Экспорт в CSV'
                    },
                    {
                        extend: 'excel',
                        text: 'Экспорт в Excel'
                    },
                    {
                        extend: 'pdf',
                        orientation: 'landscape',
                        pageSize: 'LEGAL',
                        text: 'Экспорт в PDF'
                    }
                ],
                order: params.order ?? [],
                columns: params.columns.map(v => ({data: v})),
                language: {
                    search: "Поиск в таблице: ",
                    paginate: {
                        first:      "Первая",
                        previous:   "Предыдущая",
                        next:       "Следующая",
                        last:       "Последняя"
                    },
                    emptyTable: "Нет данных",
                    info: "Показаны записи от _START_ до _END_ из _TOTAL_"
                },
                pageLength: 25
            });

        });

        return new DataTable(params);
    }


}

export default DataTable;